<app-ts1-v3-report-summary
	[reportSummary]="reportSummary"
	[previewContext]="previewContext"
	[candidateId]="candidateId"
></app-ts1-v3-report-summary>
